<template>
  <h6
    data-testid="date-label"
    class="font-weight-medium text-medium-emphasis my-4"
  >
    {{ daysFromTodayFormatted(date) }}
  </h6>
  <slot></slot>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { daysFromTodayFormatted } from "@/helpers/dateHelper"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      date: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        daysFromTodayFormatted: daysFromTodayFormatted,
      }
    },
  })
</script>
